/** @format */

import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";
import AdditonalChargesService from "../../Services/AdditionalChargesService";
import SimpleReactValidator from "simple-react-validator";
import { useLocation } from 'react-router-dom'
import CheckAccess from "../../Function/CheckAccess";

const CourierRates = () => {
  const [, setForceUpdate] = useState("");
  const validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
    })
  );
  const location = useLocation();
  let user_type = localStorage.getItem("user_type");

  const [loader, setLoader] = useState(true);
  const [fedexList, setFedexList] = useState();
  const [ups, setUps] = useState();
  const [activeTab, setActiveTab] = useState(0);

  const history = useHistory();

  useEffect(() => {
    getItemList();
  }, []);

  const getItemList = () => {
    AdditonalChargesService.getCourierrates().then((res) => {
      if (res.status) {
        setLoader(false);
        setFedexList(res.data);
      } else {
        setLoader(false);
      }
    });
  };

  const onchangeArray = (event, key, path) => {
    let { value } = event.target;

    let newArry = [...fedexList];

    let checkNest = path.split(".");

    switch (checkNest.length) {
      case 1:
        newArry[key][checkNest[0]] = value;
        break;
      case 2:
        newArry[key][checkNest[0]][checkNest[1]] = value;
        break;
      case 3:
        newArry[key][checkNest[0]][checkNest[1]][checkNest[2]] = value;
        break;
      default:
    }
    setFedexList(newArry);
  };
  const submitHandler = (key, listdata) => {
    var check_value = [];
    if (key == "Fedex") {
      check_value = [
        "vendor_type",
        "fuel_charges",
        "govt_tax",
        "peak_search_charge_express_freight_shipment",
        "peak_search_charge_express_freight_shipment_min",
        "peak_search_charge_express_shipment",
        "peak_search_charge_express_shipment_min",
      ];
      var validate =
        validator.current.fieldValid(key + " fuel charges") &&
        validator.current.fieldValid(key + " Govt. tax") &&
        validator.current.fieldValid(key + " express shipment") &&
        validator.current.fieldValid(key + " express shipment min") &&
        validator.current.fieldValid(key + " freight shipment") &&
        validator.current.fieldValid(key + " freight shipment min");
    } else if (key == "Ups") {
      check_value = ["vendor_type", "fuel_charges", "govt_tax"];
      var validate =
        validator.current.fieldValid(key + " fuel charges") &&
        validator.current.fieldValid(key + " Govt. tax");
    } else if (key == "Tnt") {
      check_value = [
        "vendor_type",
        "fuel_charges",
        "peak_search_charge_express_shipment",
        "haldling_in_out",
        "pallet_charges",
      ];
      var validate =
        validator.current.fieldValid(key + " fuel charges") &&
        validator.current.fieldValid(key + " express shipment") &&
        validator.current.fieldValid(key + " handling in/out") &&
        validator.current.fieldValid(key + " pallet charges");
    }
    // var postData = { id: listdata["_id"] };
    var postData = {};
    // check_value.forEach(function (e) {
    // postData[e] = listdata[e];
    postData = listdata;
    // });

    // if (validate) {
    AdditonalChargesService.updateCourierrates(postData).then((res) => {
      if (res.status) {
        history.push("/courier-rates");
        getItemList();
        toast.success("Additional charges updated successfully");
      } else {
        toast.error(res.message);
      }
    });
    // } else {
    //   validator.current.showMessages();
    // }
  };
  const set = (key, path) => (e) => onchangeArray(e, key, path);

  const accentOf = (name) =>
    name === "ups" ? "#351c15" : name === "fedex" ? "#4d148c" : name === "dhl" ? "#0284c7" : "#2563eb";

  const renderCarrier = (item, key) => {
    const name = String(item.service_provider || "").toLowerCase();
    const j = item.json || {};
    const express = j.express_shipment || {};
    const freight = j.express_frieght_shipment || {};

    const orMark = (
      <div className="col-12 text-center" style={{ fontWeight: 800, letterSpacing: 1, color: "#64748b", lineHeight: 1 }}>
        OR
      </div>
    );

    const stepTitle = (n, title) => (
      <div className="d-flex align-items-center" style={{ gap: 8, marginBottom: 4 }}>
        <span
          style={{
            width: 26,
            height: 26,
            borderRadius: 8,
            background: "#ea580c",
            color: "#fff",
            fontWeight: 800,
            fontSize: 14,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {n}
        </span>
        <span style={{ fontWeight: 700 }}>{title}</span>
      </div>
    );

    const field = (label, unit, value, path, wide) => {
      const isCharge = String(label).trim().toLowerCase() === "charge" || String(unit).includes("AED");
  return (
        <div className={wide ? "col-12" : "col-sm-6"}>
          <label
            className="form-label mb-1"
                      style={{
              fontSize: 12,
              fontWeight: 700,
              color: isCharge ? "#9a3412" : "#475569",
            }}
          >
            {isCharge ? "Charge" : label}
          </label>
          <div className="input-group">
                            <input
                              type="number"
                              className="form-control"
              value={value ?? ""}
              onChange={set(key, path)}
              onWheel={(e) => e.target.blur()}
              style={
                isCharge
                  ? { background: "#fff7ed", borderColor: "#fdba74", fontWeight: 700, color: "#9a3412" }
                  : undefined
              }
            />
            <span
              className="input-group-text"
              style={
                isCharge
                  ? { background: "#ea580c", color: "#fff", borderColor: "#ea580c", fontWeight: 700 }
                  : undefined
              }
            >
              {unit}
            </span>
                          </div>
                        </div>
      );
    };

    const condition = (title, help, fields, full) => (
      <div className={full ? "col-12 mb-3" : "col-lg-6 mb-3"}>
        <div
          style={{
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            padding: 14,
            height: "100%",
            background: "#fff",
          }}
        >
          <div style={{ fontWeight: 700, marginBottom: 4 }}>{title}</div>
          <div style={{ fontSize: 13, color: "#64748b", marginBottom: 12, minHeight: 40 }}>{help}</div>
          <div className="row g-2">{fields}</div>
                        </div>
                      </div>
    );

    return (
      <div className="card" style={{ borderRadius: 12 }}>
        <div className="card-body">
          <div className="row">
            {condition(
              "Transit time",
              "Days shown to the customer for this carrier.",
              field("Days", "days", item.transit_time, "transit_time")
            )}

            {name === "ups" &&
              condition(
                "Extra freight by weight",
                "Above this weight, freight is the zone price multiplied by the weight.",
                field("Above", "kg", j.ups_zone_max_kgs, "json.ups_zone_max_kgs")
              )}

            {name === "fedex" &&
              condition(
                "Extra freight by weight",
                "Above this weight, freight is the zone price multiplied by the weight.",
                field("Above", "kg", j.fedex_zone_max_kgs, "json.fedex_zone_max_kgs")
              )}

            {name !== "dhl" &&
              condition(
                "Government tax",
                "Tax is added on freight and fuel only while the chargeable weight stays within this limit.",
                field("Up to", "kg", j.min_weight, "json.min_weight")
              )}

            {name === "fedex" &&
              condition(
                "First qualify: Express or Freight",
                "Freight shipment if the chargeable weight of any single package is more than this. Otherwise it is an Express shipment.",
                field("More than", "kg", j.check_express_weight, "json.check_express_weight")
              )}

            {name === "ups" &&
              condition(
                "Shipment not accepted",
                "If length + 2 × (width + height) is above this, the shipment is refused.",
                field("L + 2(W + H) above", "cms", j.max_dimension, "json.max_dimension")
              )}

            {name === "ups" && (
              <div className="col-12 mb-3">
                <div
                  style={{
                    border: "2px solid #351c15",
                    borderRadius: 12,
                    background: "#fff",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      background: "#351c15",
                      color: "#fff",
                      padding: "12px 14px",
                      fontWeight: 800,
                      letterSpacing: 0.4,
                    }}
                  >
                    UPS SURCHARGE
                          </div>
                  <div style={{ padding: 14, background: "#faf7f5" }}>
                    {stepTitle("1", "Additional handling surcharge")}
                    <div style={{ fontSize: 13, color: "#64748b", marginBottom: 12 }}>
                      Charge once per package if any one condition is met.
                          </div>
                    <div className="row g-2">
                      {field("Gross weight above", "kg", j.additional_handling_weight, "json.additional_handling_weight")}
                      {field("Charge", "AED", j.additional_handling_charge, "json.additional_handling_charge")}
                          </div>
                    <div style={{ borderTop: "1px solid #e5e7eb", marginTop: 16, paddingTop: 14 }}>
                      {stepTitle("2", "Large package surcharge")}
                      <div style={{ fontSize: 13, color: "#64748b", marginBottom: 12 }}>
                        Charge once per package if any one condition is met.
                      </div>
                      <div className="row g-2">
                        {field("L + 2(W + H) above", "cms", j.large_package_surcharge, "json.large_package_surcharge")}
                        {field("Charge", "AED", j.large_package_surcharge_amount, "json.large_package_surcharge_amount")}
                      </div>
                            </div>
                    <div style={{ borderTop: "1px solid #e5e7eb", marginTop: 16, paddingTop: 14 }}>
                      {stepTitle("3", "Over max limit surcharge")}
                      <div style={{ fontSize: 13, color: "#64748b", marginBottom: 12 }}>
                        Charge once per package if any one condition is met.
                      </div>
                      <div className="row g-2">
                        {field("Chargeable weight above", "kg", j.max_weight, "json.max_weight", true)}
                        {orMark}
                        {field("Any side above", "cms", j.over_max_surcharge_length, "json.over_max_surcharge_length", true)}
                        {field("Charge", "AED", j.over_max_surcharge, "json.over_max_surcharge", true)}
                      </div>
                    </div>
                    <div
                      style={{
                        marginTop: 16,
                        padding: "10px 12px",
                        borderRadius: 8,
                        background: "#fff7ed",
                        border: "1px solid #fdba74",
                        color: "#9a3412",
                        fontSize: 13,
                        fontWeight: 700,
                      }}
                    >
                      <div>Note</div>
                      <div style={{ fontWeight: 600, marginTop: 6 }}>
                        If only 1 qualifies, charge 1 per package.
                      </div>
                      <div style={{ fontWeight: 600, marginTop: 4 }}>
                        If both 1 and 2 qualify, only 2 is charged per package.
                      </div>
                      <div style={{ fontWeight: 600, marginTop: 4 }}>
                        If 1, 2, and 3 all qualify, only 2 and 3 are charged per package.
                          </div>
                        </div>
                          </div>
                        </div>
                    </div>
                    )}

            {name === "dhl" && (
              <div className="col-12 mb-3">
                <div
                  style={{
                    border: "2px solid #7dd3fc",
                    borderRadius: 12,
                    background: "#fff",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      background: "#e0f2fe",
                      color: "#0c4a6e",
                      padding: "12px 14px",
                      fontWeight: 800,
                      letterSpacing: 0.4,
                    }}
                  >
                    DHL SURCHARGE
                          </div>
                  <div style={{ padding: 14, background: "#f0f9ff" }}>
                    {stepTitle("1", "Additional handling surcharge")}
                    <div style={{ fontSize: 13, color: "#64748b", marginBottom: 12 }}>
                      Charge once per package if any one condition is met.
                          </div>
                    <div className="row g-2">
                      {field("Gross weight above", "kg", j.additional_handling_weight, "json.additional_handling_weight")}
                      {field("Charge", "AED", j.additional_handling_charge, "json.additional_handling_charge")}
                        </div>
                    <div style={{ borderTop: "1px solid #e5e7eb", marginTop: 16, paddingTop: 14 }}>
                      {stepTitle("2", "Large package surcharge")}
                      <div style={{ fontSize: 13, color: "#64748b", marginBottom: 12 }}>
                        Charge once per package if any one condition is met.
                          </div>
                      <div className="row g-2">
                        {field("Any side above", "cms", j.max_dimension, "json.max_dimension")}
                        {field("Charge", "AED", j.additional_surcharge_charge, "json.additional_surcharge_charge")}
                          </div>
                        </div>
                    <div style={{ borderTop: "1px solid #e5e7eb", marginTop: 16, paddingTop: 14 }}>
                      {stepTitle("3", "Over max limit surcharge")}
                      <div style={{ fontSize: 13, color: "#64748b", marginBottom: 12 }}>
                        Charge once per package if any one condition is met.
                          </div>
                      <div className="row g-2">
                        {field("Chargeable weight above", "kg", j.per_package_weight, "json.per_package_weight", true)}
                        {orMark}
                        {field("Any side above", "cms", j.over_max_any_side, "json.over_max_any_side", true)}
                        {field("Charge", "AED", j.overweight_surcharge_amount, "json.overweight_surcharge_amount", true)}
                          </div>
                        </div>
                    <div
                      style={{
                        marginTop: 16,
                        padding: "10px 12px",
                        borderRadius: 8,
                        background: "#fff7ed",
                        border: "1px solid #fdba74",
                        color: "#9a3412",
                        fontSize: 13,
                        fontWeight: 700,
                      }}
                    >
                      <div>Note</div>
                      <div style={{ fontWeight: 600, marginTop: 6 }}>
                        If only 1 qualifies, charge 1 per package.
                          </div>
                      <div style={{ fontWeight: 600, marginTop: 4 }}>
                        If both 1 and 2 qualify, only 2 is charged. The higher charge is used, not 1.
                          </div>
                      <div style={{ fontWeight: 600, marginTop: 4 }}>
                        If 1, 2, and 3 all qualify, only 2 and 3 are charged per package.
                        </div>
                    </div>
                          </div>
                          </div>
                        </div>
            )}

            {name === "fedex" && (
              <div className="col-lg-6 mb-3">
                <div
                  style={{
                    border: "2px solid #4d148c",
                    borderRadius: 12,
                    height: "100%",
                    background: "#fff",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      background: "#4d148c",
                      color: "#fff",
                      padding: "12px 14px",
                      fontWeight: 800,
                      letterSpacing: 0.4,
                    }}
                  >
                    EXPRESS SHIPMENT
                          </div>
                  <div style={{ padding: 14, background: "#faf5ff" }}>
                  <div style={{ fontSize: 13, color: "#64748b", marginBottom: 12 }}>
                    If Express shipment. Use this only when every package is at or below the weight in First qualify.
                          </div>
                  <div className="d-flex align-items-center" style={{ gap: 8, marginBottom: 4 }}>
                    <span
                      style={{
                        width: 26,
                        height: 26,
                        borderRadius: 8,
                        background: "#ea580c",
                        color: "#fff",
                        fontWeight: 800,
                        fontSize: 14,
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      1
                    </span>
                    <span style={{ fontWeight: 700 }}>Additional handling surcharge</span>
                          </div>
                  <div style={{ fontSize: 13, color: "#64748b", marginBottom: 12 }}>
                    Charge once per package if any one condition is met.
                          </div>
                  <div className="row g-2">
                    {field("Longest side above", "cms", express.max_size, "json.express_shipment.max_size", true)}
                    {orMark}
                    {field("Second longest side above", "cms", express.second_longest_side, "json.express_shipment.second_longest_side", true)}
                    {orMark}
                    {field("L + 2(W + H) above", "cms", express.max_dimension, "json.express_shipment.max_dimension", true)}
                    {orMark}
                    {field("Volume (CBM) above", "CBM", express.volume_cbm, "json.express_shipment.volume_cbm", true)}
                    {orMark}
                    {field("Gross weight of package", "kg", express.per_pack_weight, "json.express_shipment.per_pack_weight", true)}
                    {field("Charge", "AED", express.additional_surcharge_amount, "json.express_shipment.additional_surcharge_amount", true)}
                        </div>
                  <div style={{ borderTop: "1px solid #e5e7eb", marginTop: 16, paddingTop: 14 }}>
                    <div className="d-flex align-items-center" style={{ gap: 8, marginBottom: 4 }}>
                      <span
                        style={{
                          width: 26,
                          height: 26,
                          borderRadius: 8,
                          background: "#ea580c",
                          color: "#fff",
                          fontWeight: 800,
                          fontSize: 14,
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        2
                      </span>
                      <span style={{ fontWeight: 700 }}>Large package surcharge</span>
                          </div>
                    <div style={{ fontSize: 13, color: "#64748b", marginBottom: 12 }}>
                      Charge once per package if any one condition is met.
                          </div>
                    <div className="row g-2">
                      {field("Length above", "cms", freight.large_package_length, "json.express_frieght_shipment.large_package_length", true)}
                      {orMark}
                      {field("L + 2(W + H) above", "cms", express.max_dimension, "json.express_shipment.max_dimension", true)}
                      {orMark}
                      {field("Volume (CBM) above", "CBM", freight.volume_cbm, "json.express_frieght_shipment.volume_cbm", true)}
                      {orMark}
                      {field("Gross weight above", "kg", freight.large_package_weight, "json.express_frieght_shipment.large_package_weight", true)}
                      {field("Charge", "AED", freight.large_package_surcharge_amount, "json.express_frieght_shipment.large_package_surcharge_amount", true)}
                    </div>
                          </div>
                  <div
                    style={{
                      marginTop: 16,
                      padding: "10px 12px",
                      borderRadius: 8,
                      background: "#fff7ed",
                      border: "1px solid #fdba74",
                      color: "#9a3412",
                      fontSize: 13,
                      fontWeight: 700,
                    }}
                  >
                    <div>Note</div>
                    <div style={{ fontWeight: 600, marginTop: 6 }}>
                      This section applies when every package chargeable weight is at or below the First qualify weight.
                          </div>
                    <div style={{ fontWeight: 600, marginTop: 4 }}>
                      If only 1 qualifies, charge 1 per package.
                        </div>
                    <div style={{ fontWeight: 600, marginTop: 4 }}>
                      If both 1 and 2 qualify, only 2 is charged per package.
                    </div>
                    <div style={{ fontWeight: 600, marginTop: 4 }}>
                      Freight shipment charges are not used.
                          </div>
                          </div>
                          </div>
                        </div>
                        </div>
            )}

            {name === "fedex" && (
              <div className="col-lg-6 mb-3">
                <div
                  style={{
                    border: "2px solid #b45309",
                    borderRadius: 12,
                    height: "100%",
                    background: "#fff",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      background: "#b45309",
                      color: "#fff",
                      padding: "12px 14px",
                      fontWeight: 800,
                      letterSpacing: 0.4,
                    }}
                  >
                    FREIGHT SHIPMENT
                  </div>
                  <div style={{ padding: 14, background: "#fffbeb" }}>
                    <div style={{ fontSize: 13, color: "#92400e", marginBottom: 12 }}>
                      If Freight shipment. Use this when any single package chargeable weight is more than the First qualify weight.
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: 8, marginBottom: 4 }}>
                      <span
                        style={{
                          width: 26,
                          height: 26,
                          borderRadius: 8,
                          background: "#ea580c",
                          color: "#fff",
                          fontWeight: 800,
                          fontSize: 14,
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        1
                      </span>
                      <span style={{ fontWeight: 700 }}>Over max limit surcharge</span>
                    </div>
                    <div style={{ fontSize: 13, color: "#92400e", marginBottom: 12 }}>
                      Charge once per package if any one condition is met.
                          </div>
                    <div className="row g-2">
                      {field("Any side above", "cms", freight.longest_side, "json.express_frieght_shipment.longest_side", true)}
                      {field("Charge", "AED", freight.over_max_surcharge_amount, "json.express_frieght_shipment.over_max_surcharge_amount", true)}
                          </div>
                    <div
                      style={{
                        marginTop: 16,
                        padding: "10px 12px",
                        borderRadius: 8,
                        background: "#fff7ed",
                        border: "1px solid #fdba74",
                        color: "#9a3412",
                        fontSize: 13,
                        fontWeight: 700,
                      }}
                    >
                      <div>Note</div>
                      <div style={{ fontWeight: 600, marginTop: 6 }}>
                        This section applies when any package chargeable weight is more than the First qualify weight.
                        </div>
                      <div style={{ fontWeight: 600, marginTop: 4 }}>
                        If any side is above the limit, this charge is used per package.
                          </div>
                      <div style={{ fontWeight: 600, marginTop: 4 }}>
                        Express shipment charges, 1 and 2, are not used.
                          </div>
                        </div>
                          </div>
                        </div>
                        </div>
                    )}
          </div>
                   
          {(CheckAccess(216, "edit") || user_type === "SUPERADMIN") && (
                    <button
              className="btn btn-primary ms-auto d-block"
                      onClick={() => submitHandler(item.vendor_type, item)}
                    >
              Update {item.service_provider}
                    </button>
          )}
                </div>
              </div>
    );
  };

  const list = Array.isArray(fedexList) ? fedexList : [];
  const tabIndex = activeTab >= 0 && activeTab < list.length ? activeTab : 0;
  const current = list[tabIndex];

  return (
    <>
      <p className="text-muted mb-3" style={{ fontSize: 13 }}>
        Choose a carrier. Each card is one condition. Fill the limit, then the charge.
      </p>
      <div className="d-flex flex-wrap gap-2 mb-3">
        {list.map((item, index) => {
          const selected = index === tabIndex;
          const color = accentOf(String(item.service_provider || "").toLowerCase());
          return (
            <button
              type="button"
              key={item._id || index}
              onClick={() => setActiveTab(index)}
              className="btn"
              style={{
                background: selected ? color : "#fff",
                color: selected ? "#fff" : "#334155",
                border: `1px solid ${selected ? color : "#e2e8f0"}`,
                fontWeight: 700,
                textTransform: "uppercase",
                minWidth: 120,
              }}
            >
              {item.service_provider}
            </button>
            );
          })}
      </div>
      {current && current.vendor_type === "Tnt" && (
        <div className="mb-2" style={{ fontWeight: 600 }}>Land consolidation</div>
      )}
      {current && renderCarrier(current, tabIndex)}
      <Loader isShow={loader} />
    </>
  );
};

export default CourierRates;
